import React, { useState } from "react";
import { IconButton } from "../../element-components";
import { copyTextToClipboard } from "../../util/functions";

const CopyToClipboard = ({
  text,
  margin,
  size,
  isPopover,
}) => {
  const [isClicked, setIsClicked] = useState(false);

  return (
    <IconButton
      onClick={(event) => {
        setIsClicked(true);
        copyTextToClipboard({ text, isPopover });
        setTimeout(() => {
          setIsClicked(false);
        }, 600);
      }}
      iconConfig={{
        name: isClicked ? "done" : "content_copy",
        size: size || "small",
      }}
      margin={margin || "0"}
      style={{ justifySelf: "flex-end" }}
    ></IconButton>
  );
};

export default CopyToClipboard;
